/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Styled Props for BlockWithIcon component icon.
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */

import styled from 'styled-components';

interface IIconStyleProps {
    dataName?: string;
    size: number;
}

export const IconStyled = styled.img<IIconStyleProps>`
    width: ${(props) => props.size}px;
`;
